import Suite from "./Suite";
import Loading from "./Loading";
import { MathUtils } from "three";
import { useSelector } from "react-redux";
import structure from "../utils/structure";
import { OrbitControls, Environment } from "@react-three/drei";
import React, { useRef, useState, useEffect, Suspense } from "react";

export default function Experience() {
    const controlsRef = useRef();
    const suiteRef = useRef();

    const [modelUrl, setModelUrl] = useState("meshes/suite-u.glb");
    const model = useSelector((state) => state.roomData.model);


    function resetCamera() {
        controlsRef.current.setPolarAngle(MathUtils.degToRad(75));
        controlsRef.current.setAzimuthalAngle(MathUtils.degToRad(-20));
        controlsRef.current.update();
    }

    useEffect(() => {
        const mesh = structure[0].meshes[structure[0].elements.indexOf(model)];
        setModelUrl("meshes/" + mesh);
        suiteRef.current?.updateModel();
    }, [model]);

    useEffect(() => {
        if (!controlsRef.current) { return; }
        resetCamera();
    }, [controlsRef.current]);

    return (
        <>
            <Suspense fallback={<Loading />}>
                <ambientLight intensity={0.75} />
                <OrbitControls
                    ref={controlsRef}
                    makeDefault
                    enablePan={false}
                    minDistance={2}
                    maxDistance={7.5}
                    maxPolarAngle={Math.PI / 2.15}
                />
                <Suite model={modelUrl} ref={suiteRef} />
                <Environment preset="city" />
            </Suspense>
        </>
    );
}
